import { PROCESS_STEPS } from "../lib/content";

export const Process = () => {
  return (
    <section
      id="proceso"
      data-testid="process-section"
      className="bg-white py-24 md:py-28 border-y border-slate-100"
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mb-16">
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-orange-600 mb-4">
            <span>{`{ `}</span>proceso<span>{` }`}</span>
          </div>
          <h2 className="font-display font-extrabold text-4xl md:text-5xl tracking-tight text-slate-900">
            Entregas rápidas, sin saltarse pasos.
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Nuestro framework de 5 etapas combina rigor de ingeniería con la agilidad necesaria
            para aprender en cada iteración.
          </p>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-5 gap-4 md:gap-2 relative">
          {PROCESS_STEPS.map((s, idx) => (
            <li
              key={s.n}
              data-testid={`process-step-${s.n}`}
              className="relative bg-white border border-slate-200 rounded-xl p-6 md:p-5 lg:p-6 hover:border-purple-300 hover:shadow-md transition-all"
            >
              <div className="font-mono text-sm text-orange-600 tracking-widest mb-3">
                {s.n}
              </div>
              <h3 className="font-display font-bold text-xl text-slate-900">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.text}</p>
              {idx < PROCESS_STEPS.length - 1 && (
                <span className="hidden md:block absolute top-1/2 -right-3 h-px w-6 bg-gradient-to-r from-purple-400 to-orange-400" />
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Process;
